import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { CalendarIllustration } from './Calendar';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const Calendar = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <CalendarIllustration title={title} />
  </IllustrationWrapper>
);
